var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVerified = function SvgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.866117 0.491117C1.10054 0.256696 1.41848 0.125 1.75 0.125H14.25C14.5815 0.125 14.8995 0.256696 15.1339 0.491117C15.3683 0.725538 15.5 1.04348 15.5 1.375V5.96094C15.5 12.9522 9.56436 15.266 8.40038 15.653C8.14152 15.7457 7.85848 15.7457 7.59962 15.653C6.43564 15.266 0.5 12.9522 0.5 5.96094V1.375C0.5 1.04348 0.631696 0.725537 0.866117 0.491117ZM14.25 1.375L1.75 1.375L1.75 5.96094C1.75 12.0751 6.92168 14.1117 8 14.4688C9.07832 14.1117 14.25 12.0751 14.25 5.96094V1.375Z",
    fill: "#646EC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8897 4.69358C12.128 4.94334 12.1187 5.33895 11.8689 5.57722L7.28298 9.95222C7.04135 10.1827 6.66119 10.1826 6.41976 9.95185L4.1307 7.76435C3.88115 7.52587 3.87217 7.13025 4.11065 6.8807C4.34913 6.63115 4.74475 6.62217 4.9943 6.86065L6.85193 8.63585L11.0061 4.67278C11.2558 4.43451 11.6515 4.44383 11.8897 4.69358Z",
    fill: "#646EC8"
  })));
};
export default SvgVerified;